interface Environment {
  production: boolean;
  apiUrl: string;
  namespaceProject: string;
}

export const environment = (window as any).$environment as Environment;

